'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _nodePolyglot = require('node-polyglot');

var _nodePolyglot2 = _interopRequireDefault(_nodePolyglot);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactRedux = require('react-redux');

var _components = require('components');

var _reactDocumentMeta = require('react-document-meta');

var _reactDocumentMeta2 = _interopRequireDefault(_reactDocumentMeta);

var _auth = require('redux/modules/auth');

var authActions = _interopRequireWildcard(_auth);

var _reduxRouter = require('redux-router');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Join = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    loading: state.auth.loading,
    error: state.auth.error,
    user: state.auth.user
  };
}, (0, _extends3.default)({}, authActions, { push: _reduxRouter.push })), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(Join, _Component);

  function Join(props, context, updater) {
    (0, _classCallCheck3.default)(this, Join);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Join.__proto__ || (0, _getPrototypeOf2.default)(Join)).call(this, props, context, updater));

    _this.state = {
      locale: 'fr',
      showError: false
    };
    return _this;
  }

  (0, _createClass3.default)(Join, [{
    key: 'handleJoin',
    value: function handleJoin() {
      var _this2 = this;

      var _props = this.props,
          joinCalendar = _props.joinCalendar,
          load = _props.load,
          loading = _props.loading,
          _props$params = _props.params,
          calendarId = _props$params.calendarId,
          calendarName = _props$params.calendarName,
          push = _props.push;


      if (!loading) {
        joinCalendar(calendarId, calendarName).then(function (res) {
          if (res.type === authActions.JOIN_FAIL) {
            _this2.setState({ showError: true, showSuccess: false });
          } else if (res.type === authActions.JOIN_SUCCESS) {
            load().then(function () {
              return push({ pathName: '/' });
            });
          }
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          error = _props2.error,
          loading = _props2.loading,
          calendarName = _props2.params.calendarName;
      var locale = this.state.locale;


      var phrases = require('./../../locales/' + locale + '/account.js');
      var polyglot = new _nodePolyglot2.default({
        locale: locale,
        phrases: phrases
      });
      var _state = this.state,
          showError = _state.showError,
          showSuccess = _state.showSuccess;


      var saveClassName = (0, _classnames2.default)({
        glyphicon: true,
        'glyphicon-refresh': loading,
        'cg-spinner': loading,
        'glyphicon-link': !loading
      });

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_reactDocumentMeta2.default, { title: polyglot.t('join.meta_title') }),
        _react2.default.createElement(
          'div',
          { className: 'header' },
          _react2.default.createElement(
            'h1',
            null,
            polyglot.t('join.title')
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'results' },
          showSuccess && _react2.default.createElement(
            'span',
            null,
            status
          ),
          showError && error && _react2.default.createElement(_components.BasicError, { error: error }),
          _react2.default.createElement(
            'form',
            { action: loading },
            _react2.default.createElement(
              'p',
              null,
              polyglot.t('join.explanation', { name: calendarName })
            ),
            _react2.default.createElement(
              'div',
              { className: 'form-actions no-margin text-left' },
              _react2.default.createElement(
                'button',
                {
                  type: 'button',
                  className: 'btn btn-primary',
                  onClick: this.handleJoin.bind(this)
                },
                _react2.default.createElement('i', { className: saveClassName }),
                ' ',
                polyglot.t('join.submit')
              )
            )
          )
        )
      );
    }
  }], [{
    key: 'fetchData',
    value: function fetchData(getState, dispatch) {
      if (!(0, _auth.isLoaded)(getState())) {
        return dispatch((0, _auth.load)());
      }
    }
  }]);
  return Join;
}(_react.Component), _class2.propTypes = {
  error: _propTypes2.default.any,
  joinCalendar: _propTypes2.default.func,
  load: _propTypes2.default.func,
  loading: _propTypes2.default.bool,
  params: _propTypes2.default.object,
  push: _propTypes2.default.func.isRequired,
  user: _propTypes2.default.object
}, _temp)) || _class);
exports.default = Join;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Account/Join.js
// module id = 2257
// module chunks = 0